/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';

export default class ChatsListComponent extends Component {
  @service intl;
  @service notifications;
  @service session;
  @service twoWayChat;

  @tracked showInfoModal = false;

  get yourNumber() {
    return this.session.branch.marketing.branchSmsNumber;
  }

  @action
  selectConversation(conversation) {
    const { clientId, firstName, lastName, mobile } = conversation;
    this.twoWayChat.selectClient({
      id: clientId,
      firstName,
      lastName,
      rawMobile: mobile,
    });
  }

  @action
  async copyToClipboard(text) {
    try {
      await navigator.clipboard.writeText(text);
      this.notifications.success(
        this.intl.t('two-way-chat.successfully-copied-to-clipboard')
      );
    } catch (err) {
      console.error('Failed to copy phone number to clipboard', err);
      this.notifications.failure(
        this.intl.t('two-way-chat.failed-to-copy-to-clipboard')
      );
    }
  }
}
